import React from 'react';
import styles from './HeaderListCohortList.module.scss';

export const HeaderListCohortList = ({
  height,
  heightActive,
  label,
  children,
}: {
  height: number;
  heightActive: boolean;
  label?: string;
  children: React.ReactNode;
}) => {
  const ref = React.useRef<HTMLUListElement>(null);

  const getPadding = () => {
    if (!ref.current) {
      return 0;
    }
    const computedStyle = window.getComputedStyle(ref.current);
    const padding = parseFloat(computedStyle.paddingTop);
    return padding * 2;
  };

  return (
    <li>
      {label && <span className={styles.label}>{label}</span>}
      <ul
        ref={ref}
        className={styles.root}
        style={heightActive ? { minHeight: height + getPadding() } : undefined}
        role="presentation"
      >
        {children}
      </ul>
    </li>
  );
};
